import { canCertifyAdmission } from './selectors';

/** Programme default when certification_policy does not override statement IDs. */
export const DEFAULT_MANDATORY_STATEMENTS = [
  'RECORDS_INTENDED',
  'SOURCE_STATUS_ACCURATE',
  'RELATIONSHIPS_CONFIRMED',
  'PACKAGE_COMPLETE',
];

function token(value) {
  if (value === undefined || value === null) return '';
  return String(value);
}

export function mandatoryStatementIds(admission) {
  const configured = admission?.mandatory_statements;
  if (Array.isArray(configured) && configured.length) {
    return configured.map((item) => String(item));
  }
  return [...DEFAULT_MANDATORY_STATEMENTS];
}

export function certificationContextKey(admission) {
  return [
    token(admission?.row_version),
    token(admission?.attestation_version),
    token(admission?.file_manifest_hash),
    token(admission?.admission_policy_hash),
    token(admission?.fact_snapshot_hash),
    token(admission?.assessment_hash),
    mandatoryStatementIds(admission).join(','),
  ].join('|');
}

export function certificationSnapshotComplete(admission) {
  if (!admission) return false;
  if (!token(admission.attestation_version)) return false;
  if (!token(admission.file_manifest_hash)) return false;
  if (!token(admission.fact_snapshot_hash)) return false;
  if (!token(admission.assessment_hash)) return false;
  const rowVersion = Number(admission.row_version);
  return Number.isInteger(rowVersion) && rowVersion >= 1;
}

/**
 * Snapshot the user reviewed. profile_hash may be null.
 * Does not include certification version, actor, or certification_hash.
 */
export function buildCertificationRequest(admission, acceptedStatements) {
  return {
    attestation_version: admission.attestation_version,
    accepted_statements: [...acceptedStatements],
    file_manifest_hash: admission.file_manifest_hash,
    profile_hash: admission.admission_policy_hash ?? null,
    fact_snapshot_hash: admission.fact_snapshot_hash,
    assessment_hash: admission.assessment_hash,
    row_version: admission.row_version,
  };
}

export function acceptedMandatoryStatements(admission, acceptedMap) {
  return mandatoryStatementIds(admission).filter((id) => Boolean(acceptedMap?.[id]));
}

export function allMandatoryStatementsAccepted(admission, acceptedMap) {
  const required = mandatoryStatementIds(admission);
  return required.length > 0 && required.every((id) => Boolean(acceptedMap?.[id]));
}

export function canSubmitCertification(admission, acceptedMap) {
  if (!canCertifyAdmission(admission)) return false;
  if (!certificationSnapshotComplete(admission)) return false;
  return allMandatoryStatementsAccepted(admission, acceptedMap);
}
